import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import logoMark from "../assets/logo-mark.png";

const links = [
  { href: "#fonctionnalites", label: "Fonctionnalités" },
  { href: "#pourquoi-hygio", label: "Pourquoi Hygio" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ${
        scrolled
          ? "border-ink/5 bg-paper/90 backdrop-blur"
          : "border-transparent bg-paper/0"
      }`}
    >
      <nav className="mx-auto flex max-w-content items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" className="flex items-center gap-2.5">
          <img
            src={logoMark}
            alt="Hygio"
            className="h-9 w-9 rounded-[10px] sm:h-10 sm:w-10"
          />
          <span className="text-lg font-semibold tracking-tight text-ink">
            Hygio
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-[15px] font-medium text-ink-soft transition-colors hover:text-ink"
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          className="hidden rounded-full bg-accent px-5 py-2.5 text-[15px] font-medium text-white shadow-softer transition-colors hover:bg-accent-dark md:inline-block"
        >
          Demander une démo
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center justify-center rounded-lg p-2 text-ink md:hidden"
          aria-label="Ouvrir le menu"
          aria-expanded={open}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-ink/5 bg-paper px-5 pb-5 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-[15px] font-medium text-ink-soft hover:bg-mist hover:text-ink"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-accent px-5 py-2.5 text-center text-[15px] font-medium text-white"
            >
              Demander une démo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
